@use "@fukuri-admins/ui/layout" as *;

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.innerWrapper {
  position: relative;
  overflow: auto;
}

.contentWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  background-color: background('Primary');
  border-radius: borderRadius('xl');
  @include elevation("3");
}

.modalRoot {
  padding: spacing('24');

  &.md {
    width: 512px;
  }

  &.lg {
    width: 864px;
  }

  &.xl {
    width: 1232px;
  }
}

.closeButton {
  position: absolute;
  top: spacing('4');
  right: spacing('4');
}

.title {
  @include typography('Jp/16_W6');
  color: text('High');
  margin-bottom: spacing('8');
}

.description {
  @include typography('Jp/14_W3');
  color: text('Low');
  margin-bottom: spacing('24');
}

